import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import { ZONE_PRIORITY } from '../dashboard/constants';

export const ZONE_KEYS = {
  ESCALATION: 'ESCALATION',
  RISK: 'RISK',
  MONITORING: 'MONITORING',
  SAFE: 'SAFE',
} as const;

export type ControlZone = (typeof ZONE_KEYS)[keyof typeof ZONE_KEYS];
export type ControlZoneSource = ControlZone | 'CRITICAL' | 'OTHER' | null | undefined;

export const ZONE_LABELS = {
  [ZONE_KEYS.ESCALATION]: 'Escalation',
  [ZONE_KEYS.RISK]: 'Risk',
  [ZONE_KEYS.MONITORING]: 'Monitoring',
  [ZONE_KEYS.SAFE]: 'Safe',
} as const;

export const ZONE_CONFIG: Record<ControlZone, { color: string; icon: typeof PriorityHighIcon; priority: number }> = {
  [ZONE_KEYS.ESCALATION]: { color: 'error.dark', icon: PriorityHighIcon, priority: ZONE_PRIORITY.ESCALATION },
  [ZONE_KEYS.RISK]: { color: 'error', icon: PriorityHighIcon, priority: ZONE_PRIORITY.CRITICAL },
  [ZONE_KEYS.MONITORING]: { color: 'warning', icon: PriorityHighIcon, priority: ZONE_PRIORITY.MONITORING },
  [ZONE_KEYS.SAFE]: { color: 'success', icon: ThumbUpAltIcon, priority: ZONE_PRIORITY.SAFE },
};

export const CONTROL_HEALTH_MESSAGES = {
  commercial: {
    [ZONE_KEYS.SAFE]: 'Commercial is on track',
    [ZONE_KEYS.MONITORING]: 'Commercial needs attention',
    [ZONE_KEYS.RISK]: 'Commercial issues are affecting the project',
    [ZONE_KEYS.ESCALATION]: 'Commercial requires immediate action',
  },
  projectManagement: {
    [ZONE_KEYS.SAFE]: 'Project management is on track',
    [ZONE_KEYS.MONITORING]: 'Project management needs attention',
    [ZONE_KEYS.RISK]: 'Project management issues are affecting delivery',
    [ZONE_KEYS.ESCALATION]: 'Project management requires immediate action',
  },
  engineering: {
    [ZONE_KEYS.SAFE]: 'Engineering is on track',
    [ZONE_KEYS.MONITORING]: 'Engineering needs attention',
    [ZONE_KEYS.RISK]: 'Engineering issues are affecting stability',
    [ZONE_KEYS.ESCALATION]: 'Engineering requires immediate action',
  },
  staffing: {
    [ZONE_KEYS.SAFE]: 'Staffing is on track',
    [ZONE_KEYS.MONITORING]: 'Staffing needs attention',
    [ZONE_KEYS.RISK]: 'Staffing issues are affecting delivery',
    [ZONE_KEYS.ESCALATION]: 'Staffing requires immediate action',
  },
} as const;

export const CONTRACT_RENEWAL_STEPS = {
  CREATE_OPPORTUNITY: 'CREATE_OPPORTUNITY',
  SEND_PRESALE_REQUEST: 'SEND_PRESALE_REQUEST',
  INITIATE_WITHOUT_SOW: 'INITIATE_WITHOUT_SOW',
  NO_ACTION_REQUIRED: 'NO_ACTION_REQUIRED',
} as const;

export type ContractRenewalStep = (typeof CONTRACT_RENEWAL_STEPS)[keyof typeof CONTRACT_RENEWAL_STEPS];
